import "./styles.less";

import React from "react";
import { FeaturedSearchItem } from "./FeaturedSearchItem/web";
import { useFeaturedSearch } from "./FeaturedSearch.hook";
import { EmblaCarouselHome } from "src/Components/EmblaCarousel";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

export const FeaturedSearch = () => {
	const { data, loading, error } = useFeaturedSearch();
	const screen = useBreakpoint();

	if (error) return <div>{"error"}</div>;
	if (!data) return null;

	const newData = data.featuredSearches.reduce((acco, e, i) => {
		let element = { id: i + 1, featured: e };
		if (i % 5 == 0) acco.push([element]);
		else if (i % 5 == 1 || i % 5 == 3) acco.push([element]);
		else if (i % 5 == 2 || i % 5 == 4) {
			let last = acco.pop();
			last.push(element);
			acco.push(last);
		}
		return acco;
	}, []);

	const banners = loading ? [...Array(3)] : [...newData, ...newData];

	if (!banners.length) return null;

	return (
		<>
			<h2 className="home-section-title ta-center heading heading-2 high">
				<span className="section-title">{"Búsquedas Recomendadas"}</span>
			</h2>
			<div className="featured-search">
				<EmblaCarouselHome
					title="busquedas recomendadas"
					options={{
						dragFree: false,
						navigation: screen.sm ? true : false,
						loop: true,
						align: screen.sm ? "start" : "center",
					}}
					fullWidth={true}
					widthSlide={screen.lg ? "300px" : screen.md ? "236px" : "90%"}>
					{banners.map((e, i) => {
						const uniqueItem = e.length === 1;
						return (
							<div className={"featured-search-item"} key={"featuredSearch" + i}>
								<div className="featured-search-item__container">
									{e.map(item => (
										<div
											className={`featured-search-item__container__item ${
												uniqueItem
													? `featured-search-item__container__item--unique`
													: ""
											}`}
											key={"FeaturedSearchItem" + item.id}>
											<FeaturedSearchItem item={item} loading={loading} />
										</div>
									))}
								</div>
							</div>
						);
					})}
				</EmblaCarouselHome>
			</div>
		</>
	);
};

